import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';

const Article = () => {
  const { language } = useContext(LanguageContext);
  const { articleId } = useParams();
  const blog1 = require('../img/blog-thumb01.jpg');
  const blog2 = require('../img/blog-thumb02.jpg');
  const blog3 = require('../img/blog-thumb03.jpg');

  // Données complètes des articles
  const articlesData = {
    fr: [
      {
        id: 'preparer-omra',
        title: 'Préparer Spirituellement Votre Omra',
        summary: 'Guide complet pour une préparation spirituelle optimale',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">Introduction</h2>
          <p class="mb-6">La Omra est un voyage spirituel qui nécessite une préparation mentale et religieuse approfondie. 
          Cette préparation commence des semaines, voire des mois avant votre départ.</p>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">1. Purification de l'intention</h2>
          <ul class="list-disc pl-6 mb-6 space-y-2">
            <li>Renouvelez quotidiennement votre intention (niyya) pour Allah seul</li>
            <li>Faites preuve de sincérité dans tous vos actes préparatoires</li>
          </ul>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">2. Préparation spirituelle</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <h3 class="font-bold mb-2">Augmentez vos actes d'adoration :</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>Priez les sunnas et les nawafil</li>
                <li>Lisez et méditez le Coran quotidiennement</li>
                <li>Multipliez les dhikr et les istighfar</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold mb-2">Apprentissage :</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>Étudiez les rites de la Omra avec un savant</li>
                <li>Apprenez les douas spécifiques à chaque étape</li>
                <li>Comprenez les erreurs à éviter</li>
              </ul>
            </div>
          </div>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">3. Préparation mentale</h2>
          <p class="mb-4">Préparez-vous mentalement aux épreuves potentielles :</p>
          <ul class="list-disc pl-6 mb-6 space-y-2">
            <li>Foule importante et attentes</li>
            <li>Chaleur et fatigue physique</li>
            <li>Éloignement du confort matériel</li>
          </ul>
          
          <div class="bg-blue-50 p-6 rounded-lg border-l-4 border-green-500">
            <h3 class="font-bold text-lg mb-2">Conseil important :</h3>
            <p>Commencez cette préparation au moins 40 jours avant votre départ pour une transformation spirituelle profonde.</p>
          </div>
        `,
        image: blog1
        
      },
      {
        id: 'etapes-omra',
        title: 'Les Étapes Complètes de la Omra',
        summary: 'Guide détaillé du déroulement des rites',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">1. L'ihram</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <h3 class="font-bold mb-2">Pour les hommes :</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>Portez deux pièces de tissu blanc non cousues</li>
                <li>Évitez tout vêtement moulant ou cousu</li>
                <li>Sandales ouvertes recommandées</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold mb-2">Pour les femmes :</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>Habit simple couvrant tout le corps sauf visage et mains</li>
                <li>Évitez les parfums et maquillage apparent</li>
                <li>Voile blanc recommandé mais non obligatoire</li>
              </ul>
            </div>
          </div>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">2. Le tawaf</h2>
          <p class="mb-4">Les 7 tours autour de la Kaaba :</p>
          <ol class="list-decimal pl-6 mb-6 space-y-2">
            <li>Commencez à l'angle de la Pierre Noire</li>
            <li>Priez entre chaque tour</li>
            <li>Terminez par deux raka'at derrière Maqam Ibrahim</li>
          </ol>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">3. Le sa'y</h2>
          <p class="mb-4">Les 7 allers-retours entre Safa et Marwa :</p>
          <ul class="list-disc pl-6 mb-6 space-y-2">
            <li>Commencez par Safa</li>
            <li>Marche normale sauf entre les deux lampes vertes (accélération pour les hommes)</li>
            <li>Invocations spécifiques à chaque montée</li>
          </ul>
          
          <div class="bg-yellow-50 p-4 rounded-lg mb-6">
            <h3 class="font-bold mb-2">Points importants :</h3>
            <ul class="list-disc pl-6 space-y-1">
              <li>Respectez l'ordre des rites</li>
              <li>Ne quittez pas l'état d'ihram avant d'avoir terminé</li>
              <li>Demandez conseil en cas de doute</li>
            </ul>
          </div>
        `,
        image: blog2
      },
      {
        id: 'conseils-voyage',
        title: 'Conseils Pratiques pour un Voyage Omra Réussi',
        summary: 'Tout ce que vous devez savoir pour bien préparer votre voyage',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">Préparation avant le départ</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-8">
            <div>
              <h3 class="font-bold mb-3 text-lg">📋 Documents nécessaires :</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>Passeport valide 6 mois minimum</li>
                <li>Visa Omra </li>
                <li>Certificat de vaccination (selon exigences actuelles)</li>
                <li>Photocopies des documents importants</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold mb-3 text-lg">🧳 Bagage idéal :</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>Vêtements blancs simples pour l'ihram (2-3 sets)</li>
                <li>Petit sac à dos pour les visites</li>
                <li>Médicaments personnels + trousse de premiers soins</li>
                <li>Copie du Coran de poche</li>
              </ul>
            </div>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">Sur place</h2>
          <div class="bg-blue-50 p-6 rounded-lg mb-8 border-l-4 border-blue-500">
            <h3 class="font-bold text-lg mb-3">💡 Astuces pratiques :</h3>
            <ul class="list-disc pl-6 space-y-2">
              <li>Changez de l'argent en petites coupures pour les dépenses courantes</li>
              <li>Utilisez les applications mobiles officielles (Nusuk, Tawakkalna)</li>
              <li>Privilégiez les visites tôt le matin pour éviter la foule</li>
              <li>Gardez toujours une bouteille d'eau et des dattes avec vous</li>
            </ul>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">Santé et sécurité</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-8">
            <div>
              <h3 class="font-bold mb-3 text-lg">🏥 Préventions santé :</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>Vaccins à jour (méningite, grippe, COVID-19)</li>
                <li>Protection solaire (crème, lunettes, chapeau)</li>
                <li>Chaussures confortables pour la marche</li>
                
              </ul>
            </div>
            <div>
              <h3 class="font-bold mb-3 text-lg">🔐 Sécurité :</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>Ne quittez jamais votre groupe sans prévenir</li>
                <li>Gardez vos objets de valeur en lieu sûr</li>
                <li>Notez l'adresse de votre hôtel en arabe</li>
                <li>Enregistrez les numéros d'urgence locaux</li>
              </ul>
            </div>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">Après la Omra</h2>
          <ul class="list-disc pl-6 space-y-2 mb-8">
            <li>Faites des invocations pour que votre Omra soit acceptée</li>
            <li>Partagez votre expérience avec bienveillance</li>
            <li>Maintenez les bonnes habitudes spirituelles acquises</li>
          </ul>

          <div class="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
            <h3 class="font-bold text-lg mb-2">Conseil du Prophète (ﷺ) :</h3>
            <p class="italic">"Faites suivre un acte mauvais par un acte bon qui l'effacera." (At-Tirmidhi)</p>
          
          </div>
        `,
        image: blog3
      }
    ],
    ar: [
      {
        id: 'preparer-omra',
        title: 'الاستعداد الروحي للعمرة',
        summary: 'دليل كامل للاستعداد الروحي الأمثل',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">المقدمة</h2>
          <p class="mb-6">العمرة رحلة روحانية تحتاج إلى استعداد نفسي وديني عميق. يبدأ هذا الاستعداد قبل أسابيع أو حتى أشهر من السفر.</p>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">1. تطهير النية</h2>
          <ul class="list-disc pl-6 mb-6 space-y-2" dir="rtl">
            <li>جدد نيتك يوميا لله وحده</li>
            <li>كن صادقا في جميع أعمالك التحضيرية</li>
          </ul>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">2. الاستعداد الروحي</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-6">
            <div dir="rtl">
              <h3 class="font-bold mb-2">زيادة العبادات:</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>صل السنن والنوافل</li>
                <li>اقرأ القرآن بتدبر يوميا</li>
                <li>أكثر من الذكر والاستغفار</li>
              </ul>
            </div>
            <div dir="rtl">
              <h3 class="font-bold mb-2">التعلم:</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>ادرس مناسك العمرة مع عالم</li>
                <li>تعلم الأدعية الخاصة بكل مرحلة</li>
                <li>افهم الأخطاء التي يجب تجنبها</li>
              </ul>
            </div>
          </div>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">3. الاستعداد النفسي</h2>
          <p class="mb-4">استعد نفسيا للتحديات المحتملة:</p>
          <ul class="list-disc pl-6 mb-6 space-y-2" dir="rtl">
            <li>الازدحام والتوقعات</li>
            <li>الحرارة والتعب الجسدي</li>
            <li>البعد عن الراحة المادية</li>
          </ul>
          
          <div class="bg-blue-50 p-6 rounded-lg border-l-4 border-green-500" dir="rtl">
            <h3 class="font-bold text-lg mb-2">نصيحة مهمة:</h3>
            <p>ابدأ هذا الاستعداد قبل 40 يوما على الأقل من السفر لتحول روحاني عميق.</p>
          </div>
        `,
        image: blog1
      },
      {
        id: 'etapes-omra',
        title: 'الخطوات الكاملة للعمرة',
        summary: 'دليل مفصل لخطوات المناسك',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">1. الإحرام</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-6">
            <div dir="rtl">
              <h3 class="font-bold mb-2">للرجال:</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>البس قطعتين من القماش الأبيض غير المخيط</li>
                <li>تجنب الملابس الضيقة أو المخيطة</li>
                <li>يفضل لبس النعال المفتوحة</li>
              </ul>
            </div>
            <div dir="rtl">
              <h3 class="font-bold mb-2">للنساء:</h3>
              <ul class="list-disc pl-6 space-y-1">
                <li>لباس بسيط يغطي الجسم كله ما عدا الوجه والكفين</li>
                <li>تجنب العطور والمكياج الظاهر</li>
                <li>يستحب الحجاب الأبيض لكنه ليس إلزاميا</li>
              </ul>
            </div>
          </div>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">2. الطواف</h2>
          <p class="mb-4">السبعة أشواط حول الكعبة:</p>
          <ol class="list-decimal pl-6 mb-6 space-y-2" dir="rtl">
            <li>ابدأ من الركن الأسود</li>
            <li>ادع بين كل شوط</li>
            <li>اختم بركعتي الطواف خلف مقام إبراهيم</li>
          </ol>
          
          <h2 class="text-2xl font-bold text-green-600 mb-4">3. السعي</h2>
          <p class="mb-4">السبعة أشواط بين الصفا والمروة:</p>
          <ul class="list-disc pl-6 mb-6 space-y-2" dir="rtl">
            <li>ابدأ بالصفا</li>
            <li>امشي بشكل عادي إلا بين العلمين الأخضرين (الإسراع للرجال)</li>
            <li>أدعية خاصة عند كل صعود</li>
          </ul>
          
          <div class="bg-yellow-50 p-4 rounded-lg mb-6" dir="rtl">
            <h3 class="font-bold mb-2">نقاط مهمة:</h3>
            <ul class="list-disc pl-6 space-y-1">
              <li>احترم ترتيب المناسك</li>
              <li>لا تحل من الإحرام قبل الانتهاء</li>
              <li>استشر في حالة الشك</li>
            </ul>
          </div>
        `,
        image: blog2
      },
      {
        id: 'conseils-voyage',
        title: 'نصائح عملية لرحلة عمرة ناجحة',
        summary: 'كل ما تحتاج معرفته للتحضير الجيد لرحلتك',
        content: `
          <h2 class="text-2xl font-bold text-green-600 mb-4">التحضير قبل السفر</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-8">
            <div dir="rtl">
              <h3 class="font-bold mb-3 text-lg">📋 الوثائق المطلوبة:</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>جواز سفر صالح لمدة 6 أشهر على الأقل</li>
                <li>تأشيرة العمرة </li>
                <li>شهادة التلقيح (حسب المتطلبات الحالية)</li>
                <li>صور عن الوثائق المهمة</li>
              </ul>
            </div>
            <div dir="rtl">
              <h3 class="font-bold mb-3 text-lg">🧳 الأمتعة المثالية:</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>ملابس بيضاء بسيطة للإحرام (2-3 مجموعات)</li>
                <li>حقيبة ظهر صغيرة للزيارات</li>
                <li>الأدوية الشخصية + حقيبة الإسعافات الأولية</li>
                <li>مصحف جيب</li>
              </ul>
            </div>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">في المكان</h2>
          <div class="bg-blue-50 p-6 rounded-lg mb-8 border-l-4 border-blue-500" dir="rtl">
            <h3 class="font-bold text-lg mb-3">💡 نصائح عملية:</h3>
            <ul class="list-disc pl-6 space-y-2">
              <li>حولوا المال إلى فئات صغيرة للمصاريف اليومية</li>
              <li>استخدموا التطبيقات الرسمية (نوسك، توكلنا)</li>
              <li>فضلوا الزيارات في الصباح الباكر لتجنب الازدحام</li>
              <li>احتفظوا دائما بزجاجة ماء وتمور معكم</li>
            </ul>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">الصحة والسلامة</h2>
          <div class="grid md:grid-cols-2 gap-6 mb-8">
            <div dir="rtl">
              <h3 class="font-bold mb-3 text-lg">🏥 الوقاية الصحية:</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>التطعيمات محدثة (التهاب السحايا، الإنفلونزا، كوفيد-19)</li>
                <li>وقاية من الشمس (كريم، نظارات، قبعة)</li>
                <li>أحذية مريحة للمشي</li>
              </ul>
            </div>
            <div dir="rtl">
              <h3 class="font-bold mb-3 text-lg">🔐 السلامة:</h3>
              <ul class="list-disc pl-6 space-y-2">
                <li>لا تتركوا مجموعتكم دون إبلاغ</li>
                <li>احفظوا أغراضكم القيمة في مكان آمن</li>
                <li>اكتبوا عنوان الفندق بالعربية</li>
                <li>سجلوا أرقام الطوارئ المحلية</li>
              </ul>
            </div>
          </div>

          <h2 class="text-2xl font-bold text-green-600 mb-4">بعد العمرة</h2>
          <ul class="list-disc pl-6 space-y-2 mb-8" dir="rtl">
            <li>أدعوا أن تتقبل عمرتكم</li>
            <li>شاركوا تجربتكم بحكمة</li>
            <li>حافظوا على العادات الروحية الجديدة</li>
          </ul>

          <div class="bg-green-50 p-6 rounded-lg border-l-4 border-green-500" dir="rtl">
            <h3 class="font-bold text-lg mb-2">نصيحة النبي (ﷺ):</h3>
            <p class="italic">"اتبع السيئة الحسنة تمحها" (الترمذي)</p>
            
          </div>
        `,
        image: blog3
      }
    ]
  };

  const article = articlesData[language].find(art => art.id === articleId);

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md">
          <h2 className="text-2xl font-bold text-red-600 mb-4">
            {language === 'fr' ? 'Article non trouvé' : 'المقال غير موجود'}
          </h2>
          <p className="mb-4">
            {language === 'fr' 
              ? "L'article que vous recherchez n'existe pas ou a été déplacé." 
              : "المقال الذي تبحث عنه غير موجود أو تم نقله."}
          </p>
          <a 
            href="/blog" 
            className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition-colors"
          >
            {language === 'fr' ? 'Retour au blog' : 'العودة إلى المدونة'}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <article className="bg-white p-8 rounded-lg shadow-lg" dir={language === 'ar' ? 'rtl' : 'ltr'}>
          {/* En-tête de l'article */}
          <div className="mb-8 border-b pb-6">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">{article.title}</h1>
            <div className="flex flex-wrap items-center text-gray-500 text-sm gap-4">
              <span>{article.date}</span>
              {article.author && <span>{language === 'fr' ? 'Par' : 'بواسطة'} {article.author}</span>}
            </div>
          </div>
          
          {/* Image principale */}
          <img 
            src={article.image} 
            alt={article.title} 
            className="w-full h-auto max-h-96 object-cover mb-8 rounded-lg shadow-md"
          />
          
          {/* Contenu de l'article */}
          <div 
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />
          
          {/* Pied de page de l'article */}
          <div className="mt-12 pt-6 border-t">
            <a 
              href="/blog" 
              className="inline-flex items-center text-green-600 hover:text-green-800 font-medium"
            >
              {language === 'fr' ? (
                <>
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Retour au blog
                </>
              ) : (
                <>
                  العودة إلى المدونة
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </>
              )}
            </a>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Article;